import React from 'react';

import { AttributeRow } from './AttributeRow';
import type { AttributesTableProps } from './schema-editor.types';
import styles from './schema-editor.module.css';

/**
 * Read-only table of a schema's attributes for the Data Integration → Schema
 * Definitions page. Purely presentational and fully controlled: clicking a row
 * calls onSelect (editing happens in a slide-out panel owned by the parent).
 */
export const AttributesTable: React.FC<AttributesTableProps> = ({
  rows,
  showAgentTools,
  count,
  query,
  onQueryChange,
  onAddAttribute,
  onSelect,
  selectedName,
}) => {
  const isEmpty = rows.length === 0;

  return (
    <section className={styles.attributeCard}>
      <header className={styles.attributeHeader}>
        <h2 className={styles.attributeTitle}>Attributes</h2>
        <span className={styles.attributeCount}>{count}</span>
        <input
          className={styles.attributeFilter}
          value={query}
          onChange={e => onQueryChange(e.target.value)}
          placeholder="Filter attributes"
          aria-label="Filter attributes"
        />
        <button type="button" onClick={onAddAttribute} className={styles.attributeAddButton}>
          + Add attribute
        </button>
      </header>

      <div className={styles.attributeScroll}>
        <div className={styles.attributeColumnHeader}>
          <span>Attribute</span>
          <span>Type</span>
          <span>Mapping</span>
          <span>Exposed to</span>
          <span />
        </div>

        {isEmpty ? (
          <p className={styles.attributeEmpty}>No attributes match your filter</p>
        ) : (
          rows.map(attribute => (
            <AttributeRow
              key={attribute.name}
              attribute={attribute}
              selected={attribute.name === selectedName}
              showAgentTools={showAgentTools}
              onSelect={onSelect}
            />
          ))
        )}
      </div>
    </section>
  );
};
